import React from 'react'
import { Header, Logo, Title, Week } from './style.js'

const header = props => {
    return (
        <Header mode={props.mode}>
            <Logo
                src={`img/concept/${props.concept}/logo-mobile.png`}
                mode={props.mode}
            />
            <div>
                {props.date && <Week>{props.date}</Week>}
                <Title
                    titleFontSize={props.titleFontSize}
                    lineHeight={props.height}
                >
                    {props.title}
                </Title>
            </div>
        </Header>
    )
}

export default header
